import React from "react";
import styled from "@emotion/styled";
import BackHeader from "@components/header/BackHeader";
import TabWithPanel from "@components/tab/TabWithPanel";
import { FollowerTab, FollowingTap } from "@pages/follow/_components";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Container = styled.div({
  display: "flex",
  flexDirection: "column",
});

const Follow = () => {
  const location = useLocation();
  const userName = location.state.userName;
  const { t } = useTranslation();

  const item = [
    {
      label: t("팔로우"),
      key: "1",
      children: <FollowerTab />,
    },
    {
      label: t("팔로잉"),
      key: "2",
      children: <FollowingTap />,
    },
  ];

  return (
    <Container>
      <BackHeader title={userName} />

      <TabWithPanel item={item} />
    </Container>
  );
};

export default Follow;
